import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './../../../services/auth.service';
import { Router } from '@angular/router';
import { CompanyDTO } from './../../../models/company.model';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CompanyCommercialProductDTO } from '../../../models/commercialProduct.model';

@Component({
    selector: 'app-products-limitations',
    templateUrl: './products-limitations.component.html',
    styleUrls: ['./products-limitations.component.scss']
})
export class ProductsLimitationsComponent implements OnInit {

    /**
     * Modello DTO con le info sulle limitazioni da applicare
     */
    @Input("productLimitation") productLimitation: CompanyCommercialProductDTO = null;

    /**
     * Se TRUE allora quando viene premuto il tasto SALVA non fa partire alcun salvataggio altrimenti invoca l'API
     * che aggiorna i dati del CompanyCommercialProductDTO modificato
     */
    @Input("disableSave") disableSave: boolean = true;

    /**
     * Evento di output scatenato quando viene confermata la limitazione sul company commercial product
     */
    @Output("limitationConfirmed") limitationConfirmed: EventEmitter<CompanyCommercialProductDTO> = new EventEmitter<CompanyCommercialProductDTO>();


    constructor(private router: Router, private authService: AuthService, private translate: TranslateService) { }

    ngOnInit(): void {
    }


    confirmLimitation() {
        if(this.disableSave == true && this.limitationConfirmed)
            this.limitationConfirmed.emit(this.productLimitation);
    }
}
